import { LanguageCode } from '@/types/common';
import { NO_SPACE_LANGS } from '@/utils/constants/chat';

export const isLanguageNoSpace = (languageCode: LanguageCode) => {
  return NO_SPACE_LANGS.has(languageCode);
};
